// extracted by mini-css-extract-plugin
export default {"footer":"footer-4702","reset-password-token-error":"reset-password-token-error-0465","reset-password-token-error-button":"reset-password-token-error-button-6b24"};